// extracted by mini-css-extract-plugin
export default {"title":"FaceQuestion_title__xVY+t","optional":"FaceQuestion_optional__2b4iU","faces":"FaceQuestion_faces__vjjn-","face":"FaceQuestion_face__c4tPv"};